import {applyMiddleware, createStore} from 'redux'
import root_Reducer from './Reducer/RootReducer'
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

const Store =createStore(root_Reducer,composeWithDevTools(applyMiddleware(thunk)));
export default Store